import { forwardRef } from 'react';
import type { Ref, PropsWithoutRef } from 'react';
import styled from 'styled-components';
import { hideVisually } from 'polished';

import type { ForwardRefForwardPropsComponent } from '../../types';

interface VisuallyHiddenTextProps {
  children: string;
  ref?: Ref<HTMLSpanElement>;
}

export const StyledVisuallyHiddenText = styled.span`
  ${hideVisually}
  -webkit-user-select: none;
  user-select: none;
`;

const VisuallyHiddenText: ForwardRefForwardPropsComponent<VisuallyHiddenTextProps> = forwardRef(
  function VisuallyHiddenText(
    props: PropsWithoutRef<VisuallyHiddenTextProps>,
    ref: VisuallyHiddenTextProps['ref']
  ) {
    return <StyledVisuallyHiddenText {...props} ref={ref} />;
  }
);

export default VisuallyHiddenText;
